// @flow

import React from "react";
import { localize } from "redux-i18n";

import { formatDateTime } from "@transformers/date";
import type { SelectedTask } from "@modules/reporting/reducer/tasks/types";

type OwnProps = $Exact<{
  selectedTask: SelectedTask,
}>;

type Props = $Exact<{
  ...PropsFromLocalize,
  ...OwnProps,
}>;

export const RTWAbsenceDetailsView = (props: Props) => (
  <div className="w-100">
    <div className="d-flex small-font-size justify-content-between mb-2">
      <div className="w-50 with-border pt-2 mr-2">{props.t("DATE_ABSENCE_REPORTED")}:</div>
      <div className="w-50 with-border pt-2">
        {formatDateTime(props.selectedTask.reportedAt) || props.t("N/A")}
      </div>
    </div>
    <div className="d-flex small-font-size justify-content-between mb-2">
      <div className="w-50 with-border pt-2 mr-2">{props.t("ABSENCE_START_DATE_TIME")}:</div>
      <div className="w-50 with-border pt-2">
        {formatDateTime(props.selectedTask.absenceStart) || props.t("N/A")}
      </div>
    </div>
    <div className="d-flex small-font-size justify-content-between mb-2">
      <div className="w-50 with-border pt-2 mr-2">{props.t("RTW_DATE_DATE_TIME")}:</div>
      <div className="w-50 with-border pt-2">
        {formatDateTime(props.selectedTask.rtwDate) || props.t("N/A")}
      </div>
    </div>
    <div className="d-flex small-font-size justify-content-between mb-2">
      <div className="w-50 with-border pt-2 mr-2">{props.t("WORKING_DAYS_LOST")}:</div>
      <div className="w-50 with-border pt-2">{props.selectedTask.daysLost || props.t("N/A")}</div>
    </div>
    <div className="d-flex small-font-size justify-content-between mb-2">
      <div className="w-50 with-border pt-2 mr-2">{props.t("WORKING_HOURS_LOST")}:</div>
      <div className="w-50 with-border pt-2">{props.selectedTask.hoursLost || props.t("N/A")}</div>
    </div>
    <div className="d-flex small-font-size justify-content-between mb-2">
      <div className="w-50 with-border pt-2 mr-2">{props.t("ABSENCE_REASON")}:</div>
      <div className="w-50 with-border pt-2">
        {((props.selectedTask || {}).absenceReason || {}).name ||
          ((props.selectedTask || {}).absenceReason || {}).label ||
          props.t("N/A")}
      </div>
    </div>
    <div className="d-flex small-font-size justify-content-between mb-2">
      <div className="w-50 with-border pt-2 mr-2">{props.t("WORK_RELATED_HEADER")}</div>
      <div className="w-50 with-border pt-2">
        {props.selectedTask.isWorkRelated ? props.t("YES") : props.t("NO")}
      </div>
    </div>
    <div className="d-flex small-font-size justify-content-between mb-2">
      <div className="w-50 with-border pt-2 mr-2">{props.t("ACCIDENT_RELATED_HEADER")}</div>
      <div className="w-50 with-border pt-2">
        {props.selectedTask.isAccidentRelated ? props.t("YES") : props.t("NO")}
      </div>
    </div>
    <div className="d-flex small-font-size justify-content-between mb-2">
      <div className="w-50 with-border pt-2 mr-2">{props.t("DATE_ABSENCE_CLOSED")}:</div>
      <div className="w-50 with-border pt-2">
        {formatDateTime(props.selectedTask.closeAt) || props.t("N/A")}
      </div>
    </div>
    <div className="d-flex small-font-size justify-content-between mb-2">
      <div className="w-50 with-border pt-2 mr-2">{props.t("ALERT_TRIGGERED")}:</div>
      <div className="w-50 with-border pt-2">
        {props.selectedTask.alertsTriggered || props.t("N/A")}
      </div>
    </div>
    <div className="d-flex small-font-size justify-content-between mb-2">
      <div className="w-50 with-border pt-2 mr-2">{props.t("CONTACT_PHONE_NUMBER")}:</div>
      <div className="w-50 with-border pt-2">
        {props.selectedTask.contactPhoneNumber || props.t("N/A")}
      </div>
    </div>
  </div>
);

export default localize()(RTWAbsenceDetailsView);
